import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Input } from "reactstrap";
import "./index.scss";
import FilterFile from "./FilterFile";
import IrsIncomeAutoPopulateList from "../../../../components/common/IrsIncomeAutoPopulateList";
const DocSearchBlock = ({ _handleSearch, _filterDocs, __filterDocs, _resetFilter, _handleElasticSearch, elasticSearchList, focusSearchFlag, __focusSearch, filter, status, sort, order, sortOrder }) => {

	const [keyword, setKeyword] = useState(filter);
	const [focusSearch, setFocusSearch] = useState(false);

	console.log('elasticSearchList', elasticSearchList)



	/***
	 * @description function use for search trigger
	 * @param {refObj} event accepting element event 
	 */
	const onKeyDownEvent = (event) => {
		if (event.key === 'Enter') {
			if (event.target.value.trim() && event.target.value.trim().replace(/\./g, "")) {
				setKeyword(event.target.value)
				setFocusSearch(false)
				_handleSearch(event.target.value);
			} else {
				setKeyword(event.target.value.trim().replace(/\./g, ""))
				setFocusSearch(false)
				_handleSearch(null);
			}
		}
	}

	const __handleElasticSearch = (val) => {
		if (val.trim() && val.trim().replace(/\./g, "")) {
			setFocusSearch(true)
			setKeyword(val)
			_handleElasticSearch(val.trim());
		} else {
			setFocusSearch(false)
			setKeyword(val.trim().replace(/\./g, ""));
			_handleSearch(null, null)
		}
	};

	const handleSelectedAction = (val, moreInfoObj) => {
		moreInfoObj.keyword = keyword
		//setKeyword(val)
		setFocusSearch(false)
		_handleSearch(val, moreInfoObj);

	}
	/***
	 * @description function use for handle elastic search view more
	 */
	const viewMore = () => {
		setFocusSearch(false)
		_handleSearch(keyword, null);

	}
	/***
	 * @description function use for handle restElasticSearch
	 */
	const restElasticSearch = () => {
		setKeyword('')
		setFocusSearch(false)
		_handleSearch(null, null);

	}

	const resetDocs = (v) => {

		_resetFilter(v)
		setKeyword('')
		//(null);
		//setSortBySelected(null);
	}

	const onClick = (v) => {
		__focusSearch(true);
		if (keyword) {
			_handleElasticSearch(keyword.trim());
			setFocusSearch(true)
		}
	}
	return (<>
		<div className="docs-search-blc position-relative d-flex align-items-center position-relative">
			<Input type="text" value={keyword} placeholder="Search" onChange={(e) => { if (e.target.value !== " ") { __handleElasticSearch(e.target.value) } }} onClick={(e) => { onClick(e.target.value) }}
				onKeyDown={(e) => {
					if (e.key === '.') {
						e.stopPropagation();
						e.preventDefault();
					} else {
						onKeyDownEvent(e)
					}
				}} />
			<span className="icon position-absolute d-inline-flex align-items-center justify-content-center">
				<FontAwesomeIcon icon={faSearch} />
			</span>
			<FilterFile
				className="filter-blc filter-blc2 position-absolute status-icon"
				_filterSelected={status}
				_sortBySelected={sort}
				sortOrder={sortOrder}
				_filter={(v) => { _filterDocs(v) }} __filter={(sortBy, order, sortOrder) => { __filterDocs(sortBy, order, sortOrder); }} />

			<Button data-toggle="tooltip" data-placement="top" title={'Reset'} color="link" onClick={resetDocs} className="reset-btn position-absolute">
				<FontAwesomeIcon icon={faRedoAlt} />
			</Button>
			{/*focusSearch && elasticSearchList?.length > 0 && ( 
				 <AutoPopulateList  searchList={elasticSearchList} _handleSelectedAction={(val) => handleSelectedAction(val)} _handleFilePageChange={viewMore} />
				)*/}
			{focusSearch && focusSearchFlag && (
				<IrsIncomeAutoPopulateList searchList={elasticSearchList} _handleSelectedAction={(val, moreInfoObj) => handleSelectedAction(val, moreInfoObj)} _handleFilePageChange={viewMore} _resetSearch={restElasticSearch} />
			)}
		</div>
		<div className="file-filter-block docs-search-blc">
			<div className="row-block d-flex align-items-center">
				<div className="lbl">Showing:- {status ? '' : 'All records'}</div>
				<div className="right-col d-flex align-items-center ms-auto">
					<ul className="status-items">
						<li className="d-flex align-items-center">
							<span className={`${status == 'false' ? 'inprogress-lbl' : status == 'true' ? 'success-lbl' : status == 'Review' ? 'inprogress-lbl' : ''}`}>{status == 'false' ? 'Pending' : status == 'true' ? 'Ready' : status == "Review" ? "Ready for Review" : ''}</span>
						</li>
					</ul>
					<ul className="sort-status-item">
						<li className="d-inline-flex align-items-center">
							<span className="icon">
								{order == -1 ? <img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-down.svg')} alt="arrow" /> :
									<img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-up.svg')} alt="arrow" />}
							</span>
							<span className="txt">
								{sort ? sort == 'createdAt' ? 'Date' : 'Loan No' : ''} <span>-</span>{order ? order == -1 ? 'Desc' : 'Asc' : ''}
							</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</>
	)
};
export default DocSearchBlock;